import React from "react"
import { HeroTitle } from "./Title"
import { HeroWrapper, StyledVideo } from "./styles"
import { OutlineText } from "components/Hero/OutlineText"
import { ParallaxPhotos } from "components/Hero/ParallaxPhotos"

const Hero = props => {
  return (
    <>
      <HeroWrapper mouseBlack={props.mouseBlack} photoUrl={props.photoUrl}>
        {props.children}
        {props.videoUrl ? (
          <>
            <StyledVideo autoPlay="autoplay" muted="muted" loop="loop">
              <source src={props.videoUrl} type="video/mp4" />
              Twoja przeglądarka nie wspiera tagu video.
            </StyledVideo>
            <HeroTitle {...props} />
            <OutlineText color={props.color}>{props.outlineTitle}</OutlineText>
          </>
        ) : (
          <>
            <HeroTitle {...props}>WYSTAWY</HeroTitle>
            <OutlineText color={props.color}>{props.outlineTitle}</OutlineText>
          </>
        )}
        <ParallaxPhotos
          imagesHook={props.imagesHook}
          bigtitle={props.bigTitle}
        />
      </HeroWrapper>
    </>
  )
}
export { Hero }
